import { animated, useSpring } from "@react-spring/web";
import { useState } from "react";
import classNames from "classnames";
import dayjs from "dayjs";

// Constants
import { STATUS_NAME } from "constants/transactions";

// Hooks
import useTranslate from "hooks/useTranslate";

// Icons
import ArrowIcon from "assets/icons/arrowDown.svg?react";

// Types
import { TRANSACTION_STATUS } from "types/Transaction";
import useFormatBalance from "../../../hooks/useFormatBalance";
import { TransactionItem } from "../TransactionListItemMobile";
import { PAYMENT_METHODS_CODES } from "../../../constants/paymentMethodsConst";
import SvgIcon from "../SvgIcon/SvgIcon";

import "./styles.sass";

const TransactionListItemDesktop = ({ transaction }: TransactionItem) => {
  const { id, createdAt, updatedAt, method, amount, remoteId, status } =
    transaction;

  const [isOpen, setIsOpen] = useState(false);
  const isPayment =
    (PAYMENT_METHODS_CODES.REFERRAL ||
      PAYMENT_METHODS_CODES.MANUAL ||
      PAYMENT_METHODS_CODES.BONUS) !== method.code;

  const { height, opacity, transform } = useSpring({
    height: isOpen && isPayment ? 75 : 0,
    opacity: isOpen && isPayment ? 1 : 0,
    transform: isOpen && isPayment ? "rotate(180deg)" : "rotate(0deg)",
  });

  const t = useTranslate();

  const formatBalance = useFormatBalance();

  const statusClass = classNames("TransactionListItemDesktop__status", {
    [status]: !!status,
  });

  return (
    <div className="TransactionListItemDesktop">
      <div
        className="TransactionListItemDesktop__main"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="TransactionListItemDesktop__method">
          {/* {method && method.logo ? (
            <img src={method.logo} alt={method.name} />
          ) : (
            ""
          )} */}
          <SvgIcon
            svgString={method.logo}
            className="TransactionListItemDesktop__logo"
            alt={method.name}
          />

          <div className="TransactionListItemDesktop__method_title">
            {method ? t(method.name) : ""}
          </div>
        </div>
        <div className="TransactionListItemDesktop__id" title={id}>
          {id}
        </div>
        <div className="TransactionListItemDesktop__date">
          {dayjs(createdAt).format("HH:mm / DD.MM")}
        </div>
        <div className="TransactionListItemDesktop__amount">
          {formatBalance(amount)}
        </div>
        <div className={statusClass}>{t(STATUS_NAME[status])}</div>
        {isPayment && (
          <animated.div
            className="TransactionListItemDesktop__arrow"
            style={{ transform }}
          >
            <ArrowIcon />
          </animated.div>
        )}
      </div>
      <animated.div
        className="TransactionListItemDesktop__additional"
        style={{ height, opacity }}
      >
        <div className="TransactionListItemDesktop__transaction">
          <div className="TransactionListItemDesktop__title">
            {t("profile.balance.history.id")} {method ? `${method.name}:` : ""}
          </div>
          <span>{remoteId}</span>
        </div>
        <div className="TransactionListItemDesktop__empty" />
        <div className="TransactionListItemDesktop__approved">
          <span>{t("profile.balance.history.created.long")}: </span>
          <span>
            {status === TRANSACTION_STATUS.SUCCESS
              ? dayjs(updatedAt).format("HH:mm DD/MM")
              : "n/a"}
          </span>
        </div>
        <div className="TransactionListItemDesktop__empty" />
        <div className="TransactionListItemDesktop__empty" />
        <div className="TransactionListItemDesktop__empty" />
      </animated.div>
    </div>
  );
};

export default TransactionListItemDesktop;
